export const AdminRoles = ['SiteAdmin', 'Partner', 'SuperAdmin'];

export const SuperAdminRoles = ['Partner', 'SuperAdmin'];

export const Feature = Object.freeze({
  autoOnboardNewHire: 13,
  autoApplyEssChanges: 12,
  standardScheduling: 11,
  mobileApplication: 10,
  benefitsManagement: 9,
  centeralizedData: 8,
  advancedTime: 7,
  advancedHR: 5,
  hr: 2,
  platformPricing: 1,
});

export const FeatureKeys = Object.keys(Feature);

export const Permissions = Object.freeze({
  canAddAndEditPartnerLoginsPermissions: 39,
  canAccessTwpPortal: 40,
  basePartnerAccess: 41,
  canViewBilling: 30,
  canAccessBillingFunctions: 53,
  canViewFileGuardianDetails: 63,
});

export const PartnerPermissionLevel = Object.freeze({
  none: 'None',
  all: 'All',
  partner: 'Partner',
  selfAndPartner: 'SelfAndPartner',
});
